export type MovieItem = {
  id: string;
  title: string;
  origin: string;
  year: string;
  region: string;
  runtime: string;
  director: string;
  cast: string;
  genres: string[];
  score: number;
  heat: number;
  releaseDate: string;
  cinemaStatus: string;
  badge: string;
  summary: string;
  poster: string;
};

export const allMovies: MovieItem[] = [
  {
    id: 'wu-gang',
    title: '雾港谜案',
    origin: 'The Fog Harbor Case',
    year: '2026',
    region: '中国香港',
    runtime: '126 分钟',
    director: '岑亦寒',
    cast: '陆见川 / 苏芷宁 / 何维安',
    genres: ['悬疑', '剧情'],
    score: 8.7,
    heat: 9840,
    releaseDate: '2026-09-26',
    cinemaStatus: '院线在映',
    badge: '本周口碑',
    summary: '一座被浓雾封港的旧城，接连出现的旧档案把两代人的沉默重新翻开，推理线与情感线交替推进。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20of%20a%20foggy%20harbor%20city%20at%20night%2C%20lone%20silhouette%20on%20a%20pier%2C%20muted%20amber%20and%20deep%20teal%20palette%2C%20dramatic%20soft%20light%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20editorial%20photography&width=400&height=600&seq=movie-poster-01&orientation=portrait',
  },
  {
    id: 'chang-feng',
    title: '长风渡海',
    origin: 'Across the Long Wind',
    year: '2026',
    region: '中国大陆',
    runtime: '148 分钟',
    director: '孟知遥',
    cast: '裴行舟 / 温若初 / 江晏',
    genres: ['剧情', '冒险'],
    score: 8.4,
    heat: 8920,
    releaseDate: '2026-09-19',
    cinemaStatus: '院线在映',
    badge: '热映中',
    summary: '以一段跨海远航为线索，讲述一群人在漫长旅途中如何重新理解故乡与告别，画面辽阔。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20of%20a%20lone%20sailing%20ship%20crossing%20a%20vast%20sea%20under%20huge%20clouds%2C%20warm%20amber%20sunlight%20and%20muted%20teal%20tones%2C%20epic%20minimal%20composition%2C%20film%20grain%20texture%2C%20editorial%20photography&width=400&height=600&seq=movie-poster-02&orientation=portrait',
  },
  {
    id: 'xing-ji',
    title: '星际拾荒者',
    origin: 'Star Scavenger',
    year: '2026',
    region: '中国大陆',
    runtime: '134 分钟',
    director: '柯一鸣',
    cast: '霍骁 / 蓝汐 / 詹姆·罗',
    genres: ['科幻', '冒险'],
    score: 8.1,
    heat: 9410,
    releaseDate: '2026-10-03',
    cinemaStatus: '院线在映',
    badge: '新片上映',
    summary: '在废弃轨道站之间打捞残骸的拾荒者，意外捡到一段不该存在的信号，由此卷入一场漫长的追寻。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20of%20a%20space%20scavenger%20floating%20near%20a%20broken%20orbital%20station%2C%20glowing%20amber%20lights%20against%20cold%20dark%20teal%20space%2C%20dramatic%20rim%20light%2C%20film%20grain%20texture%2C%20minimal%20composition&width=400&height=600&seq=movie-poster-03&orientation=portrait',
  },
  {
    id: 'chun-shan',
    title: '春山可望',
    origin: 'Spring Hills in Sight',
    year: '2026',
    region: '中国大陆',
    runtime: '118 分钟',
    director: '林砚秋',
    cast: '许南枝 / 方既明',
    genres: ['爱情', '剧情'],
    score: 8.3,
    heat: 7630,
    releaseDate: '2026-09-12',
    cinemaStatus: '网络上线',
    badge: '口碑佳作',
    summary: '两个在南方小镇错过又重逢的人，把十几年的心事放进一封迟迟没寄出的信里，节奏舒缓。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20romantic%20film%20poster%20style%20of%20a%20misty%20southern%20hillside%20town%20at%20dusk%2C%20two%20small%20figures%20on%20a%20stone%20path%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20gentle%20light%2C%20film%20grain%20texture%2C%20minimal%20composition&width=400&height=600&seq=movie-poster-04&orientation=portrait',
  },
  {
    id: 'shen-yuan',
    title: '深渊回响',
    origin: 'Echoes from the Deep',
    year: '2026',
    region: '中国大陆',
    runtime: '122 分钟',
    director: '宋亦白',
    cast: '黎舟 / 曲蔓 / 白岸',
    genres: ['惊悚', '悬疑'],
    score: 7.9,
    heat: 8210,
    releaseDate: '2026-10-01',
    cinemaStatus: '院线在映',
    badge: '新片上映',
    summary: '一支水下测绘队深入废弃矿坑，随着信号一次次回弹，队员们开始怀疑队里多了一个人。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20film%20poster%20style%20of%20a%20dark%20flooded%20mine%20shaft%20with%20divers%20headlamps%20glowing%2C%20deep%20teal%20water%20and%20faint%20amber%20light%2C%20tense%20atmosphere%2C%20film%20grain%20texture%2C%20minimal%20composition&width=400&height=600&seq=movie-poster-05&orientation=portrait',
  },
  {
    id: 'shi-wei',
    title: '食味人间',
    origin: 'A Taste of Us',
    year: '2025',
    region: '中国大陆',
    runtime: '102 分钟',
    director: '郑未迟',
    cast: '纪录影像',
    genres: ['纪录', '家庭'],
    score: 8.9,
    heat: 7180,
    releaseDate: '2026-09-05',
    cinemaStatus: '网络上线',
    badge: '高分推荐',
    summary: '跟着六位普通人的灶台，记录一年四季里因为一顿饭而聚拢的家人、邻居与陌生人。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20film%20poster%20style%20of%20a%20warm%20home%20kitchen%20with%20steaming%20pots%20and%20soft%20daylight%2C%20amber%20and%20warm%20green%20tones%2C%20cozy%20intimate%20atmosphere%2C%20film%20grain%20texture%2C%20minimal%20composition&width=400&height=600&seq=movie-poster-06&orientation=portrait',
  },
  {
    id: 'wu-ye',
    title: '午夜列车',
    origin: 'The Midnight Line',
    year: '2026',
    region: '日本',
    runtime: '115 分钟',
    director: '长谷川泠',
    cast: '高桥凉 / 石川遥 / 森下悠',
    genres: ['悬疑', '剧情'],
    score: 8.0,
    heat: 6890,
    releaseDate: '2026-09-27',
    cinemaStatus: '即将同步',
    badge: '院线同步',
    summary: '一列穿过夜色不停站的列车，六位互不相识的乘客因为一段被反复播放的广播被迫合作。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20suspense%20film%20poster%20style%20of%20a%20night%20train%20corridor%20with%20warm%20glowing%20windows%20streaking%20by%2C%20deep%20teal%20shadows%20and%20amber%20highlights%2C%20film%20grain%20texture%2C%20minimal%20moody%20composition&width=400&height=600&seq=movie-poster-07&orientation=portrait',
  },
  {
    id: 'shan-ye',
    title: '山野来客',
    origin: 'Visitor of the Wild',
    year: '2026',
    region: '中国大陆',
    runtime: '108 分钟',
    director: '苗青野',
    cast: '谷雨 / 小满 / 老周',
    genres: ['家庭', '冒险'],
    score: 8.2,
    heat: 6420,
    releaseDate: '2026-09-14',
    cinemaStatus: '网络上线',
    badge: '合家欢',
    summary: '护林员父女在山里过暑假，一头受伤的幼鹿让原本生疏的两人重新学会信任与耐心。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20family%20film%20poster%20style%20of%20a%20lush%20green%20mountain%20forest%20with%20soft%20morning%20mist%20and%20a%20path%2C%20warm%20amber%20sunlight%20and%20deep%20green%20tones%2C%20gentle%20hopeful%20mood%2C%20film%20grain%20texture%20minimal%20composition&width=400&height=600&seq=movie-poster-08&orientation=portrait',
  },
  {
    id: 'yin-yi',
    title: '银翼追缉',
    origin: 'Silver Wing Chase',
    year: '2026',
    region: '美国',
    runtime: '131 分钟',
    director: 'D. 卡尔森',
    cast: 'R. 麦尔斯 / 陈岚 / J. 佩里',
    genres: ['动作', '悬疑'],
    score: 7.6,
    heat: 8760,
    releaseDate: '2026-10-04',
    cinemaStatus: '院线在映',
    badge: '新片上映',
    summary: '一名机场调度员被迫在跨洋航班与地面追踪之间做选择，节奏紧凑，动作场面连环推进。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20film%20poster%20style%20of%20a%20silver%20airliner%20silhouette%20on%20a%20night%20runway%20with%20dramatic%20lights%2C%20cool%20teal%20night%20and%20warm%20amber%20glow%2C%20high%20tension%20mood%2C%20film%20grain%20texture%20minimal%20composition&width=400&height=600&seq=movie-poster-09&orientation=portrait',
  },
  {
    id: 'jiu-cheng',
    title: '旧城故事',
    origin: 'Tales of the Old Town',
    year: '2025',
    region: '中国台湾',
    runtime: '112 分钟',
    director: '吴维纲',
    cast: '林彦廷 / 简心苹',
    genres: ['剧情', '家庭'],
    score: 8.6,
    heat: 5980,
    releaseDate: '2026-08-29',
    cinemaStatus: '网络上线',
    badge: '高分推荐',
    summary: '老街拆迁前的最后一个夏天，一家开了四十年的照相馆，为街坊留下最后一批合影。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20film%20poster%20style%20of%20an%20old%20town%20street%20with%20small%20photo%20studio%20and%20warm%20afternoon%20light%2C%20soft%20amber%20and%20muted%20green%20tones%2C%20nostalgic%20mood%2C%20film%20grain%20texture%20minimal%20composition&width=400&height=600&seq=movie-poster-10&orientation=portrait',
  },
  {
    id: 'guang-nian',
    title: '光年之外的信',
    origin: 'Letters Beyond Light Years',
    year: '2026',
    region: '中国大陆',
    runtime: '125 分钟',
    director: '温子澄',
    cast: '顾兆 / 余星禾',
    genres: ['科幻', '爱情'],
    score: 8.5,
    heat: 7340,
    releaseDate: '2026-10-02',
    cinemaStatus: '即将同步',
    badge: '院线同步',
    summary: '相隔数光年的两个人靠延迟多年的信件维系的感情，在时间差里被反复考验。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20romance%20poster%20style%20of%20a%20lone%20figure%20under%20a%20vast%20starfield%20with%20a%20faint%20glowing%20letter%20shape%2C%20deep%20teal%20space%20and%20warm%20amber%20glow%2C%20poetic%20minimal%20composition%2C%20film%20grain%20texture&width=400&height=600&seq=movie-poster-11&orientation=portrait',
  },
  {
    id: 'quan-feng',
    title: '拳风',
    origin: 'The Wind of Fists',
    year: '2026',
    region: '中国大陆',
    runtime: '119 分钟',
    director: '赵铁生',
    cast: '石岩 / 麦冬 / 阿凯',
    genres: ['动作', '剧情'],
    score: 8.0,
    heat: 6510,
    releaseDate: '2026-09-20',
    cinemaStatus: '院线在映',
    badge: '热映中',
    summary: '一个被伤病劝退的老拳手回到小城开馆收徒，把没打完的那场比赛交到年轻人手里。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20sports%20drama%20film%20poster%20style%20of%20a%20lone%20boxer%20in%20a%20dim%20gym%20with%20dust%20in%20the%20light%2C%20warm%20amber%20lamp%20glow%20and%20deep%20teal%20shadows%2C%20gritty%20mood%2C%20film%20grain%20texture%20minimal%20composition&width=400&height=600&seq=movie-poster-12&orientation=portrait',
  },
];

export const todayUpdates = [
  { id: 'u1', time: '09:00', title: '雾港谜案', type: '网络上线', detail: '高清正片上线，附带幕后制作特辑 1 则', section: '最新电影' },
  { id: 'u2', time: '11:30', title: '长风渡海', type: '加映场次', detail: '院线新增午间与深夜场次，同步更新排片', section: '院线同步' },
  { id: 'u3', time: '13:15', title: '星际拾荒者', type: '新片上映', detail: '全国院线正式上映，首日排片占比可观', section: '新片上映' },
  { id: 'u4', time: '15:40', title: '食味人间', type: '分集更新', detail: '纪录片更新第 5、6 集，主题为「夏夜小摊」', section: '今日更新' },
  { id: 'u5', time: '18:00', title: '银翼追缉', type: '新片上映', detail: '热门场次预售开启，动作专场同步上线', section: '新片上映' },
  { id: 'u6', time: '19:20', title: '深渊回响', type: '口碑更新', detail: '新增观众短评与剧照集，热搜位次上升', section: '热播榜' },
  { id: 'u7', time: '21:00', title: '光年之外的信', type: '预告放出', detail: '正式预告与角色特辑放出，院线同步进入倒计时', section: '院线同步' },
  { id: 'u8', time: '22:30', title: '旧城故事', type: '高分推荐', detail: '评分稳定在 8.6，进入本周高分推荐片单', section: '高分推荐' },
];

export const guideSteps = [
  {
    id: 'g1',
    step: '01',
    title: '想追更快，先看「今日更新」',
    text: '当天新上线、分集更新、加映与预告都会集中在这里，按时间排序，一次看完不用来回找。',
  },
  {
    id: 'g2',
    step: '02',
    title: '不确定看什么，就看「热播榜」',
    text: '榜单按近期热度排序，前几名通常代表大众讨论度较高；想避开热门也可以从榜尾往上看。',
  },
  {
    id: 'g3',
    step: '03',
    title: '想进影院，锁定「院线同步」',
    text: '标注院线在映与即将同步的作品会写明状态，方便你判断是现在能看，还是再等几天。',
  },
  {
    id: 'g4',
    step: '04',
    title: '在意质量，翻「高分推荐」',
    text: '评分较高的作品会附一句推荐理由，帮你在一分钟之内判断它是不是你今晚想看的那一部。',
  },
];

export const faqs = [
  {
    id: 'f1',
    q: '九七电影院最新电影都包含哪些内容？',
    a: '「最新电影」主要指近期上线与刚刚上映的作品，页面中会同时标注上映或上线日期、类型与时长，并结合今日更新与院线同步一起展示，方便你判断哪些是新片。',
  },
  {
    id: 'f2',
    q: '热播榜是按什么顺序排列的？',
    a: '热播榜按近期热度从高到低排列，热度综合了讨论量与关注度的一般性指标。它可以当作参考，但不代表评分高低，想看质量可以对照高分推荐。',
  },
  {
    id: 'f3',
    q: '今日更新一般什么时候更新？',
    a: '「今日更新」按当天时间顺序罗列，通常包含新上线、分集更新、加映场次与预告放出。每天内容会变化，越晚查看通常越完整。',
  },
  {
    id: 'f4',
    q: '院线同步板块怎么用？',
    a: '该板块区分「院线在映」与「即将同步」两种状态。在映代表当前影院可看，即将同步代表网络或流媒体端还在等待，具体时间以页面标注为准。',
  },
  {
    id: 'f5',
    q: '高分推荐的评分是最终结论吗？',
    a: '评分与推荐理由基于页面整理的参考信息，用于帮你缩小选择范围，并不代替你自己的观影感受。口味因人而异，建议结合类型标签一起判断。',
  },
  {
    id: 'f6',
    q: '这个页面能直接播放影片吗？',
    a: '该页面是影视资讯聚合页，用于了解片单、排行与更新节奏，本身不提供播放。你可以根据页面信息，自行前往正规渠道观看。',
  },
];

export const pageStats = [
  { id: 's1', value: '12', unit: '部', label: '本期在册片单' },
  { id: 's2', value: '8', unit: '条', label: '今日更新条目' },
  { id: 's3', value: '10', unit: '部', label: '热播榜收录' },
  { id: 's4', value: '5', unit: '部', label: '院线同步追踪' },
];